import { listStepConfigs } from '@/services'
import { Plugins } from '../../acl/plugins'

const workspace = {
  state: {
    name: null,
    steps: [],
    currentStep: null
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_STEPS: (state, steps) => {
      state.steps = steps
      if (state.steps.length > 0) {
        state.currentStep = steps.filter(x => x.ui)[0]
      }
    },
    SET_CURRENT_STEP: (state, currentStep) => {
      state.currentStep = currentStep
    }
  },
  actions: {
    async SetWorkspace ({ commit, dispatch }, workspace) {
      commit('SET_NAME', workspace)
      await dispatch('FetchSteps', workspace)
    },

    async FetchSteps ({ commit }, workspace) {
      const { data: configs } = await listStepConfigs(workspace, 'model')
      const steps = Object.values(configs)
        .filter(async function (config) {
          const permission = Plugins.check('Step', ['read'], { 'workspace': workspace, 'step': config.name })
          return config.ui && permission
        })
        .sort((x, y) => x.order - y.order)
        .map(x => ({
          ...x,
          displayName: x.displayName || x.name
        }))
      console.log('steps', steps)
      commit('SET_STEPS', steps)
    },

    async GetSteps ({ state, dispatch }, workspace) {
      if (state.steps.length > 0) return state.steps
      await dispatch('FetchSteps', workspace)
      return state.steps
    }
  }
}

export default workspace
